import React from 'react';
import { Button, Typography } from '@mui/material';
import { FormattedDate, FormattedMessage } from 'react-intl';

import { moment } from '../../../../../../../I18n';

export default function TitleWhenAnswered({
  isAnswered,
  createdAt,
  submissionOngoing,
  showResponse,
  setShowResponse,
}: any) {
  if (!isAnswered || !createdAt) {
    return null;
  }

  return (
    <>
      <Typography sx={{ display: 'inline-flex' }}>
        <FormattedMessage
          id="FORM_RESPONSES.CREATED_AT"
          values={{
            date: <FormattedDate value={createdAt} />,
            time: moment(createdAt).format('LT'),
            b: (chunks: any) => chunks,
          }}
        />
      </Typography>
      <Button
        sx={{ ml: 1, verticalAlign: 'baseline' }}
        variant="text"
        onClick={() => setShowResponse(!showResponse)}
      >
        {submissionOngoing ? (
          <FormattedMessage id="FORM_RESPONSES.UPDATE_RESPONSE" />
        ) : (
          <FormattedMessage id="FORM_RESPONSES.SHOW_RESPONSE" />
        )}
      </Button>
    </>
  );
}
